class RequestFailedException extends Error {
  constructor(key, details) {
    super();
    this.key = key;
    this.details = details;
  }
}

export default RequestFailedException;
